import React from 'react';

import LinearProgress from '@/components/LinearProgress';
import { useBaseCard } from '@/modules/content/components/ContentCard/BaseCard/Provider';
import { BaseCardComposition } from '@/modules/content/components/ContentCard/BaseCard/types';

const Progress: BaseCardComposition['Progress'] = ({ className, color }) => {
  const { progress, name } = useBaseCard();

  if (!progress) {
    return null;
  }

  return (
    <LinearProgress
      ariaLabel={name}
      className={className}
      color={color}
      size="small"
      value={progress}
      width={86}
    />
  );
};

export default Progress;
